export enum FcdMapVersionStatusType {
  NEWER = 'newer',
  EQUAL = 'equal',
  OLDER = 'older'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/fcdmapversionstatustype.ts